// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-hR4","question":"styles_question__1EL6Z","description":"styles_description__3iLHH"};